export type WinTier = 'small-win' | 'win' | 'big-win' | 'jackpot';

/** Legacy tier boundaries, evaluated only after the immutable result is presented. */
export function getWinTier(winCents: number, betCents: number): WinTier | null {
  if (!Number.isSafeInteger(winCents) || winCents < 0) throw new RangeError('Der Gewinn muss ein gültiger Centbetrag sein.');
  if (!Number.isSafeInteger(betCents) || betCents <= 0) throw new RangeError('Der Einsatz muss ein positiver Centbetrag sein.');
  if (winCents === 0) return null;
  if (winCents >= betCents * 12) return 'jackpot';
  if (winCents >= betCents * 6) return 'big-win';
  if (winCents > betCents) return 'win';
  return 'small-win';
}
